import api from '../api';

const sendMessageToCompletionsAPI = async (body) => {
  try {
    const url = `/v1/chat/completions`;
    const { data } = await api.post(url, body);
    return data;
  } catch (error) {
    console.log(error);
    return error;
  }
};

const sendToBatchChatCompletionsAPI = async (body) => {
  try {
    const url = `/v1/chat/completions/batch`;
    const { data } = await api.post(url, body);
    return data;
  } catch (error) {
    console.log(error);
    return error;
  }
};

const enqueueMessageToCompletionsAPI = async (body) => {
  try {
    const url = `/v1/chat/completions/queue`;
    const { data } = await api.post(url, body);
    return data;
  } catch (error) {
    console.log(error);
    return error;
  }
};

const checkTaskStatusInCompletionsQueue = async (taskId) => {
  try {
    const url = `/v1/chat/completions/queue/${taskId}`;
    const { data } = await api.get(url);
    return data;
  } catch (error) {
    console.error('Error fetching data:', error);
  }
};

const streamMessageToCompletionsAPI = async (
  body,
  { onChunk, onDone, onError, signal } = {}
) => {
  try {
    const base = api?.defaults?.baseURL?.replace(/\/$/, '') || '';
    const url = `${base}/v1/chat/completions/stream`;

    const token = localStorage.getItem('login-token');
    const apiKey = localStorage.getItem('x-api-key');

    const headers = {
      'Content-Type': 'application/json',
      'Accept': 'text/event-stream',
      ...(api?.defaults?.headers?.common || {}),
      ...(api?.defaults?.headers?.post || {}),
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(apiKey ? { 'x-api-key': apiKey } : {}),
    };

    const controller = signal ? null : new AbortController();
    const res = await fetch(url, {
      method: 'POST',
      headers,
      body: JSON.stringify(body),
      signal: signal || controller?.signal,
    });

    if (!res.ok || !res.body) {
      const text = await res.text().catch(() => '');
      throw new Error(`Stream HTTP ${res.status}: ${text}`);
    }

    const reader = res.body.getReader();
    const decoder = new TextDecoder('utf-8');
    let buffer = '';

    while (true) {
      const { value, done } = await reader.read();
      if (done) break;

      buffer += decoder.decode(value, { stream: true });

      let idx;
      while ((idx = buffer.indexOf('\n\n')) !== -1) {
        const frame = buffer.slice(0, idx);
        buffer = buffer.slice(idx + 2);

        const lines = frame.split('\n');
        let event = 'message';
        const dataLines = [];

        for (let l of lines) {
          l = l.trim();
          if (!l || l.startsWith(':')) continue;     // comments / keep-alives
          if (l.startsWith('event:')) event = l.slice(6).trim();
          else if (l.startsWith('data:')) dataLines.push(l.slice(5).trim());
        }

        if (dataLines.length === 0) continue;
        const dataStr = dataLines.join('\n');

        if (event === 'error') {
          try {
            const payload = JSON.parse(dataStr);
            onError?.(new Error(payload?.message || 'stream error'));
          } catch {
            onError?.(new Error(dataStr));
          }
          continue;
        }

        try {
          const msg = JSON.parse(dataStr);
          if (msg.chunk !== undefined) onChunk?.(msg.chunk);
          if (msg.done) onDone?.(msg);
        } catch {
          // fallback: non-JSON payload, pass through as text
          onChunk?.(dataStr);
        }
      }
    }

    // flush any remaining bytes
    const tail = decoder.decode();
    if (tail) {
      // handle any final, non-delimited tail if you need it
    }

    onDone?.({ done: true });
    return { ok: true, abort: () => controller?.abort?.() };
  } catch (error) {
    onError?.(error);
    return { ok: false, error };
  }
}

export default {
  sendMessageToCompletionsAPI,
  sendToBatchChatCompletionsAPI,
  enqueueMessageToCompletionsAPI,
  checkTaskStatusInCompletionsQueue,
  streamMessageToCompletionsAPI,
};
